import { Component, EventEmitter, Input, Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { Utils } from 'src/modules/utils/shared/utils';
import { FrontendField } from '../../netgen/FrontendField';
import { TableCellType } from '../../netgen/TableCellType';

@Component({
    selector: 'sm-tree-table-cell',
    templateUrl: './sm-tree-table-cell.component.html',
    styleUrls: ['./sm-tree-table-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SmTreeTableCellComponent {

    _Utils = Utils;

    _TableCellType = TableCellType;
    @Input()
    type: TableCellType;
    @Input()
    value: any;
    @Input()
    editable = false;
    @Input()
    showNull = true;
    @Input()
    editor: FrontendField;
    @Output()
    clicked = new EventEmitter<any>();
    @Output()
    valueChange = new EventEmitter<any>();

    buttonClick(): void {
        this.clicked.emit(null);
    }

    switchBool(): void {
        this.setValue(!this.value);
    }

    afterEdit(): void {
        this.valueChange.emit(this.value);
    }

    private setValue(value: any): void {
        this.value = value;
        this.valueChange.emit(value);
    }

    getListItemSpeakingName(): string {
        if (this.editor?.listItems == null) {
            return this.value;
        }
        let result = this.editor.listItems.find(li => li.value == this.value);
        return result != null ? result.label : this.value;
    }

}
